import React, { PropsWithChildren, useCallback, useEffect, useRef, useState } from 'react';
import LicenceDataSource from '../datasource/LicenceDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import dxChart from "devextreme/viz/chart"
import Chart, { IChartOptions, Export, Tooltip} from 'devextreme-react/chart';
import { GlobalProps } from '../utils/GlobalProps';
import { ObjectUtils } from '../utils/ObjectUtils';

export interface IReportChartOptions extends IChartOptions {
    dataStore?: any;
    runDate?: any;
    innerRef?: any;
}

const ReportChart: React.FC<PropsWithChildren<IReportChartOptions>> = ({ dataStore, runDate, ...props }) => {
    let chartRef = props.innerRef || useRef(null);
    const chartInstance = (): dxChart => {
        let chart = chartRef.current;
        if (chart) {
            let instance: dxChart | null = chart.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }


    const refreshChart = () => {
        if (chartInstance()) {
            chartInstance().refresh();
        }
    }
    useEffect(
        () => {

        }
        ,
        []
    );
    const customizeTooltip = (pointInfo) => {
        let str = `<div>
                    <div class="tooltip-header">${pointInfo.argumentText}</div>
                    <div class="tooltip-body">`;
        for (let point of pointInfo.points) {
            str += `<div class="series-name">
                            <span class='top-series-name'>${point.seriesName}</span>:
                        </div>
                        <div class="value-text">
                            <span class='top-series-value'>${
                                GlobalProps.tryConvertValueToLocaleNumberPrecision(point.valueText, 2)
                            }</span >
                        </div>`;
        }
        str += `</div>
                </div>`;

        return {
            html: `${str}`
        };
    }

    ObjectUtils.evalAllProperty(props, props, false, 1, 4);

    return (
        <Chart            
//            id="chart"
//            title={title}
            className="report-chart"
            dataSource={dataStore}
            ref={chartRef}
            {...props}
        >
            <Export enabled={false} />
            <Tooltip
                enabled={true}
                shared={true}
                customizeTooltip={customizeTooltip}
            />
            {props.children}
        </Chart >
    );
}


export default React.memo(ReportChart);

